import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';

import { ClassNameType } from 'interfaces';

const styles = {
  component: (className: ClassNameType) => (
    twMerge(classNames(
      'rounded-xl',
      'bg-lightGray',
      'flex',
      'justify-center',
      'items-center',
      '!px-6 md:!px-8',
      '!py-12',
    ), className)),
};

export default styles;
